import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const StyledSliderContainer = styled.div`
    position: relative;
`;

export const StyledSliderNavButton = styled.button`
    display: none;
    position: absolute;
    background-color: ${({ theme }) => theme.color.secondary};
    border: none;
    border-radius: 50%;
    box-shadow: 0 2px 12px rgb(0 0 0 / 12%);
    cursor: pointer;
    width: 42px;
    height: 42px;
    top: 50%;
    margin-top: -21px;
    z-index: 10;

    &.swiper-button-disabled {
        display: none;
    }

    ${mq.gt.sm} {
        display: initial;
    }
`;

export const StyledSliderPrevNavButton = styled(StyledSliderNavButton)`
    left: -21px;

    & > svg {
        transform: rotate(180deg);
    }
`;

export const StyledSliderNextNavButton = styled(StyledSliderNavButton)`
    right: -21px;
`;

export const StyledBulletContainer = styled.section`
    user-select: none;
    width: 100%;

    & .bullets {
        & .my-bullet {
            width: 100%;
            height: 6px;
            margin-right: 13px;
            border-radius: 32px;
            background: rgb(236 236 240 / 30%);

            ${mq.lt.md} {
                height: 3px;
                background: rgb(236 236 240 / 50%);
            }

            &.bullet-active {
                background: ${({ theme }) => theme.color.secondary};
            }
        }
    }

    & .swiper {
        width: 100%;
    }
`;

export const StyledSliderBullets = styled.div`
    position: relative;
    width: 100%;
    height: 6px;
    padding: 0 16px;
    display: flex;
    top: 20px;
    z-index: 2;
    cursor: pointer;

    ${mq.lt.md} {
        height: 3px;
        top: 15px;
    }
    ${mq.lt.sm} {
        padding: 0;
    }
`;
